import {IDeepLinkBuilder} from '../deep-link-builder.interface';
import {IDeepLinkActionChain} from '../../deep-link-actions/deep-link-action-chain';

export class DeepLinkJsonObjectBuilder implements IDeepLinkBuilder {
  buildDeepLinkUrl(actionsChain: IDeepLinkActionChain): string {

    let deepLinkObject: any = {};
    let resultedMarketingParams: any = {};

    let currentActionIndex = -1;

    let currentActionsChainPointer: IDeepLinkActionChain | null = actionsChain;
    while(currentActionsChainPointer) {
      let actionPropName = '';
      let idPropName = '';

      if(currentActionIndex === -1) {
        actionPropName = 'action';
        idPropName = 'id'
      } else if(currentActionIndex === 0) {
        actionPropName = 'action_next';
        idPropName = 'id_next'
      } else {
        actionPropName = 'action_next' + currentActionIndex;
        idPropName = 'id_next'  + currentActionIndex;
      }

      deepLinkObject[actionPropName] = currentActionsChainPointer.descriptor.action;
      if(currentActionsChainPointer.descriptor.actionParams && currentActionsChainPointer.descriptor.actionParams.id) {
        deepLinkObject[idPropName] = currentActionsChainPointer.descriptor.actionParams.id;
      }

      let marketingParams = currentActionsChainPointer.descriptor.marketingParams;
      if(marketingParams) {
        if(marketingParams.dl) {
          resultedMarketingParams.dl = marketingParams.dl;
        }

        if(marketingParams.wtc) {
          resultedMarketingParams.wtc = marketingParams.wtc;
        }
      }

      currentActionsChainPointer = currentActionsChainPointer.nextAction;
      currentActionIndex++;
    }

    if(Object.keys(deepLinkObject).length === 0) {
      return ''
    }

    deepLinkObject = {...deepLinkObject, ...resultedMarketingParams};

    // replace " with ' - for some reason cause to JSON parsing to fail.
    const deepLinkObjectAfterConvert = JSON.stringify(deepLinkObject).split('"').join('\'')

    return "#deeplink=" + deepLinkObjectAfterConvert;
  }
}
